export default {
  search_results: 'Здесь будут отображаться результаты поиска',
  search_no_results: 'Поиск не дал результатов',
  search_result_level: 'ур. - {level}',
  manager: 'Менеджер',
  team: 'Команда',
  tournament: 'Турнир',
  player: 'Игрок',
}
